const initialState = {
  lang: 'es',
  access_token: '',
  expires_at: '',
  token_type: ''
}

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LANG': return { ...state, lang: action.lang }
    case 'SET_TOKEN_DATA': return { ...state, ...action.tokenData }
    default: return state
  }
}

export default settingsReducer